/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Vchip_Type_MpaaInputs */

const en_subtitle_export_vchip_type_mpaa = /** @type {(inputs: Subtitle_Export_Vchip_Type_MpaaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MPAA`)
};

const fr_subtitle_export_vchip_type_mpaa = /** @type {(inputs: Subtitle_Export_Vchip_Type_MpaaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MPAA`)
};

const de_subtitle_export_vchip_type_mpaa = /** @type {(inputs: Subtitle_Export_Vchip_Type_MpaaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MPAA`)
};

const it_subtitle_export_vchip_type_mpaa = /** @type {(inputs: Subtitle_Export_Vchip_Type_MpaaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MPAA`)
};

const ru_subtitle_export_vchip_type_mpaa = /** @type {(inputs: Subtitle_Export_Vchip_Type_MpaaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MPAA`)
};

const es_subtitle_export_vchip_type_mpaa = /** @type {(inputs: Subtitle_Export_Vchip_Type_MpaaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asociación Médica Popular`)
};

const zh_cn2_subtitle_export_vchip_type_mpaa = /** @type {(inputs: Subtitle_Export_Vchip_Type_MpaaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`美国电影协会`)
};

const ja_subtitle_export_vchip_type_mpaa = /** @type {(inputs: Subtitle_Export_Vchip_Type_MpaaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MPAA`)
};

const hi_subtitle_export_vchip_type_mpaa = /** @type {(inputs: Subtitle_Export_Vchip_Type_MpaaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एमपीएए`)
};

const pt_pt2_subtitle_export_vchip_type_mpaa = /** @type {(inputs: Subtitle_Export_Vchip_Type_MpaaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MPAA`)
};

/**
* | output |
* | --- |
* | "MPAA" |
*
* @param {Subtitle_Export_Vchip_Type_MpaaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_vchip_type_mpaa = /** @type {((inputs?: Subtitle_Export_Vchip_Type_MpaaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Vchip_Type_MpaaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_vchip_type_mpaa(inputs)
	if (locale === "de") return de_subtitle_export_vchip_type_mpaa(inputs)
	if (locale === "it") return it_subtitle_export_vchip_type_mpaa(inputs)
	if (locale === "ru") return ru_subtitle_export_vchip_type_mpaa(inputs)
	if (locale === "es") return es_subtitle_export_vchip_type_mpaa(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_vchip_type_mpaa(inputs)
	if (locale === "ja") return ja_subtitle_export_vchip_type_mpaa(inputs)
	if (locale === "hi") return hi_subtitle_export_vchip_type_mpaa(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_vchip_type_mpaa(inputs)
	return en_subtitle_export_vchip_type_mpaa(inputs)
});